"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperWithFonts = exports.Wrapper = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styled_components_1 = require("styled-components");
const redalerts_theme_theme_1 = require("@redwigwam/redalerts.theme.theme");
const redalerts_theme_fonts_1 = require("@redwigwam/redalerts.theme.fonts");
function Wrapper({ theme, children }) {
    const overridddenTheme = (0, core_1.createMuiTheme)(theme || redalerts_theme_theme_1.rwwTheme);
    const GlobalStyle = (0, styled_components_1.createGlobalStyle) `
  ${overridddenTheme.typography}
  `;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GlobalStyle, null),
        react_1.default.createElement(core_1.ThemeProvider, { theme: overridddenTheme },
            react_1.default.createElement(styled_components_1.ThemeProvider, { theme: overridddenTheme }, children))));
}
exports.Wrapper = Wrapper;
function WrapperWithFonts({ children }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(redalerts_theme_fonts_1.Fonts, null),
        react_1.default.createElement(Wrapper, null, children)));
}
exports.WrapperWithFonts = WrapperWithFonts;
//# sourceMappingURL=wrapper.js.map